import { POPUP, SAVE_COMMODITY } from '../constants'

const initState = {
    request: null,
    response: null,
    error: null,
}

export default (state = initState, action) => {
    switch (action.type) {
        case SAVE_COMMODITY.LOAD:
            return {
                ...state,
                request: action.request,
                response: null,
                error: null,
            }
        case SAVE_COMMODITY.SUCCESS:
            return {
                ...state,
                response: action.response,
            }
        case SAVE_COMMODITY.ERROR:
            return {
                ...state,
                error: action.error,
            }
        case POPUP.CLOSE:
            return {
                ...state,
                error: null,
            }
        case SAVE_COMMODITY.CLEAR:
            return {
                ...state,
                response: null,
                error: null,
            }
        default:
            return state
    }
}